export enum UserType {
  SuperAdmin = 1,
  Admin = 2,
  Practitioner = 3,
}
export enum RoleUserType {
  Admin = 2,
  Practitioner = 3,
}
export enum FileDirectoryPath {
  PatientDir = 'PTDocs',
  PatientIdentityDir = 'IdentityDocs',
  PatientVisitDocs = 'VisitDocs',
  PatientRefDocs = 'RefDocs',
  ReferralDocs = 'ReferralDocs',
  AppDocsDir = 'AppDocs',
  TaskDocsDir = 'TaskDocs',
  InvestigationResultDocs = 'InvestigationResultDocs',
  OtherDocs = 'OtherDocs',
  EmailDocsDir = 'EmailDocs',
  CorrespondenceDir = 'CorrespondenceDocs',
}

export enum AnswerType {
  Single_Value = 1,
  Multi_Value = 2,
  Text = 3,
  Date = 4,
}

export enum LabType {
  Lab = 1,
  Imaging = 2,
}

export enum EmailRefType {
  VisitNote = 'VisitNote',
}

export enum PaymentModeType {
  UPI = 1,
  Offline = 2,
}

export enum DocumentRefType {
  VisitNoteTemplate = 'VisitNoteTemplate',
  ReportTemplate = 'ReportTemplate',
  EmailTemplate = 'EmailTemplate',
  PatientVisit = 'PatientVisit',
  PatientPrescription = 'PatientPrescription',
  PatientInvoice = 'PatientInvoice',
  PatientInvestigationOrder = 'PatientInvestigationOrder',
  PatientReferral = 'PatientReferral',
}

export enum AttachmentRefType {
  EmailTemplateAttechment = 1,
  Task = 2,
  EmailAttechment = 3,
  PatientDocs = 4,
}

export enum NotificationRefType {
  AppointmentReminder = 'Appointment Reminder',
  AppointmentConfirmationReminder = 'Appointment Confirmation Reminder',
  PendingTask = 'Pending Task',
}
